// extracted by mini-css-extract-plugin
export var dropdownButton = "_1x-0";
export var fullWidthDropdownButton = "_1x-1";
export var icon = "_1x-3";
export var iconPlaceholder = "_1x-2";
export var menuItemRow = "_1x-5";
export var shortcutContainer = "_1x-4";